import { render, staticRenderFns } from "./DrillResultMath.vue?vue&type=template&id=f825cb30&scoped=true&lang=pug&"
import script from "./DrillResultMath.vue?vue&type=script&lang=ts&"
export * from "./DrillResultMath.vue?vue&type=script&lang=ts&"
import style0 from "./DrillResultMath.vue?vue&type=style&index=0&id=f825cb30&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f825cb30",
  null
  
)

export default component.exports